const newMediaTypes = [
    {
        id: 'graphic',
        link: '/graphic',
        specifications: {
            acceptedFileExtensions: [
                '.psd',
                '.ai',
                '.fig',
                '.indd',
                '.sketch',
                '.xd',
            ],
            acceptedApps: [
                'Adobe Illustrator',
                'Adobe InDesign',
                'Adobe Photoshop',
                'Adobe XD',
                'Figma',
                'Sketch',
            ],
        },
    },
    {
        id: 'notion',
        link: '/notion',
        specifications: {
            acceptedApps: ['Notion'],
        },
    },
    {
        id: 'ui',
        link: '/ui',
        specifications: {
            acceptedFileExtensions: [
                '.xd',
                '.fig',
                '.sketch',
            ],
            acceptedApps: [
                'Figma',
                'Sketch',
                'Adobe XD',
            ],
        },
    },
    {
        id: 'presentation',
        link: '/presentation',
        specifications: {
            acceptedFileExtensions: [
                '.key',
                '.ppt',
                '.pptm',
                '.pptx',
                '.potx',
                '.kth',
            ],
            acceptedApps: [
                'PowerPoint',
                'Keynote',
            ],
        },
    },
];

// eslint-disable-next-line import/prefer-default-export
export { newMediaTypes };
